export function formatStockName(stock) {
  if (!stock) {
    return '-';
  }
  if (stock.marketId && stock.marketName) {
    return `${stock.marketId.split('.')[0]} ${stock.marketName}`;
  }
  if (stock.MarketId && stock.MarketName) {
    return `${stock.MarketId.split('.')[0]} ${stock.MarketName}`;
  }
}

export function formatStockNumber(stock) {
  if (!stock) {
    return '-';
  }
  if (stock.marketId) {
    return stock.marketId.split('.')[0];
  }
  if (stock.MarketId) {
    return stock.MarketId.split('.')[0];
  }
}
